import type { ReportPreviewPageModel } from 'app/modules/analytics/modules/reports/utils/buildReportPreviewPages';
import type { ReportMetricRowDefinition } from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPlatformMetricRows';

interface PageScopedReportMetrics {
  pagePerformanceTileMetrics: string[];
  pageContentTileMetrics: string[];
}

export function resolvePageScopedReportMetrics(
  page: ReportPreviewPageModel,
  selectedPerformanceMetrics: string[],
  selectedContentMetrics: string[],
): PageScopedReportMetrics {
  const selectedPerformance = new Set(selectedPerformanceMetrics);
  const selectedContent = new Set(selectedContentMetrics);

  return {
    pagePerformanceTileMetrics: page.performanceTileMetrics.filter((metric) =>
      selectedPerformance.has(metric),
    ),
    pageContentTileMetrics: page.contentMetrics.filter((metric) =>
      selectedContent.has(metric),
    ),
  };
}

export function getUncoveredReportMetricDefinitions(
  rowConfigs: { definitions: ReportMetricRowDefinition[] }[],
  selectedMetrics: string[],
  sectionKind: 'performance' | 'content',
): ReportMetricRowDefinition[] {
  const coveredKeys = new Set(
    rowConfigs.flatMap((row) =>
      row.definitions.map((definition) => definition.metricKey),
    ),
  );

  return selectedMetrics
    .filter((metric) => !coveredKeys.has(metric))
    .map((metricKey) => ({ metricKey, sectionKind }));
}

export function rowHasVisibleMetrics(
  rowDefinitions: ReportMetricRowDefinition[],
  pageMetrics: string[],
): boolean {
  const pageMetricSet = new Set(pageMetrics);

  return rowDefinitions.some((definition) =>
    pageMetricSet.has(definition.metricKey),
  );
}
